export const cannotBeNegative = ({ value, message }: { value: string; message: string }) => {
  if (Math.sign(Number(value)) === -1) {
    return message;
  }

  return undefined;
};
